import { render, staticRenderFns } from "./PackageTrendingCard.vue?vue&type=template&id=14fd8e88&scoped=true"
import script from "./PackageTrendingCard.vue?vue&type=script&lang=js"
export * from "./PackageTrendingCard.vue?vue&type=script&lang=js"
import style0 from "./PackageTrendingCard.vue?vue&type=style&index=0&id=14fd8e88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14fd8e88",
  null
  
)

export default component.exports